angular.module('businessThread')
    .controller('BusinessThreadCreateController', function ($rootScope, $uibModalInstance, BusinessThread, BusinessThreadConst, toastr, data) {
        this.form = {
            id: data && data.id,
            symbol: data && data.symbol,
            description: data && data.description,
            activeFrom: data && data.activeFrom,
            activeTo: data && data.activeTo
        }

        this.cancel = () => $uibModalInstance.dismiss('cancel')

        this.save = () => {
            let payload = angular.copy(this.form)
            let request = payload.id
                ? BusinessThread.update({id: payload.id}, payload).$promise
                : BusinessThread.save(payload).$promise

            return request.then(thread => {
                $rootScope.$broadcast(BusinessThreadConst.eventUpdate)
                toastr.success('Zapisano wątek')
                $uibModalInstance.close(thread)
            }).catch(() => toastr.error('Nie udało się zapisać wątku'))
        }
    })
